import React, { useEffect, useState, useRef } from "react";
import { ValidationMessage, hasRole } from "../../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  STATE_ADMIN_USER_EDIT,
  STATE_ADMIN_USER_UPDATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  ROLE_LIST_DROPDOWN
} from "../../../routes/routes";
import { toast } from "react-toastify";
import { FullPageLoader } from '../../../components/common/Loader'; // Import the loader component
import { STATE_ADMIN_USER_UPDATED } from "../../../constant/constant";
import Select from "react-select";

const StateAdminUserEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [filter, setFilter] = useState([]);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [roleOptions, setRoleOptions] = useState({});
  const [type, setType] = useState("password");
  const [type1, setType1] = useState("password");

  const selectStateRef = useRef(null);

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
  };

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    // console.log(requestBody);
    axios
      .put(STATE_ADMIN_USER_UPDATE + id, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(STATE_ADMIN_USER_UPDATED);
          navigate("/state-admin-users");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios.get(STATE_ADMIN_USER_EDIT + id).then((res) => {
      if (res.status === 200 && res.data.success) {
        let responseData = res.data.data;
        setForm({
          name: responseData?.name,
          email: responseData?.email,
          mobile_number: responseData?.mobile_number,
          country_id: responseData?.country_id || 0,
          country_id_selected: {
            value: Number(responseData?.country_id),
            label: responseData?.country_name,
          },
          state_id: responseData?.state_id || 0,
          state_id_selected: {
            value: Number(responseData?.state_id),
            label: responseData?.state_name,
          },
          admin_role_id: responseData?.admin_role_id,
          admin_role_id_selected: {
            value: Number(responseData?.admin_role_id),
            label: responseData?.admin_role_name,
          },
        });
      }
    }).finally(() => {
      setLoading(false);
    });

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch role data
        const roleResponse = await axios.get(ROLE_LIST_DROPDOWN);
        const fetchedRoleOptions = roleResponse.data.data;
        setRoleOptions(fetchedRoleOptions);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading || btnDisabled} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">State Admins</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/state-admin-users"}>
                    <span>State Admin Users List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit State Admin User</span></li>
              </ol>

            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/state-admin-users"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">

        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit User</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">

                    {hasRole([1]) &&
                      <div className="col-6 mb-3">
                        <label htmlFor="country_id" className="form-label">
                          Country<span className="text-danger">*</span>
                        </label>
                        <Select
                          isClearable
                          name="country_id"
                          isDisabled={true}
                          options={countryOptions}
                          onChange={(selected) => {
                            handleStateClear();
                            setForm({ ...form, country_id: Number(selected.value), country_id_selected: selected, state_id: null, state_id_selected: null })
                            setFilter({
                              ...filter,
                              country_id: selected?.value,
                              state_id: null,
                            });
                          }}
                          value={form?.country_id_selected}
                        />
                        <ValidationMessage error={errors} name="country_id" />
                      </div>
                    }

                    {hasRole([1, 6]) &&
                      <div className="col-6 mb-3">
                        <label htmlFor="state_id" className="form-label">
                          State<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="state_id"
                          isClearable
                          ref={selectStateRef}
                          options={stateOptions}
                          isDisabled={true}
                          value={form?.state_id_selected}
                          onChange={(selected) => { setForm({ ...form, state_id: selected.value, state_id_selected: selected }) }}
                        />
                        <ValidationMessage error={errors} name="state_id" />
                      </div>
                    }

                    <div className="col-6 mb-3">
                      <label htmlFor="admin_role_id" className="form-label">
                        Admin Role<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={roleOptions}
                        value={form?.admin_role_id ? form?.admin_role_id_selected : ""}
                        onChange={(selected) => { setForm({ ...form, admin_role_id: selected.value, admin_role_id_selected: selected }) }}
                      />
                      <ValidationMessage error={errors} name="admin_role_id" />
                    </div>


                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="name"
                        >
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          defaultValue={form?.name}
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="email"
                        >
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Email"
                          onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                          defaultValue={form?.email}
                        />
                        <ValidationMessage error={errors} name="email" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="mobile_number"
                        >
                          Mobile Number<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control hide-arrow"
                          id="mobile_number"
                          placeholder="Mobile No"
                          onChange={(e) =>
                            setForm({ ...form, mobile_number: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, mobile_number: e.target.value })
                          }
                          defaultValue={form?.mobile_number}
                        />
                        <ValidationMessage error={errors} name="mobile_number" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="password"
                        >
                          Password
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type}
                            className="form-control"
                            id="password"
                            placeholder="***********"
                            onChange={(e) =>
                              setForm({ ...form, password: e.target.value })
                            }
                          />
                          {type === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType('text')}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType('password')}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage error={errors} name="password" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="confirm_password"
                        >
                          Confirm Password
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type1}
                            className="form-control"
                            id="confirm_password"
                            placeholder="***********"
                            onChange={(e) =>
                              setForm({
                                ...form,
                                confirm_password: e.target.value,
                              })
                            }
                          />
                          {type1 === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1('text')}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1('password')}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage
                          error={errors}
                          name="confirm_password"
                        />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/state-admin-users"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        &nbsp; Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StateAdminUserEdit;
